export default __webpack_public_path__ + "static/media/cert_cmd.cc8fa5a1.png";